'use strict';

angular.module('app').directive('sharethis', function ($timeout, $rootScope, gettextCatalog) {
  return {
    restrict: 'A',
    replace: true,
    scope: {
      gPlus: '=',
      email: '=',
      title: '@',
      description: '@',
      url: '@',
    },
    template: "<div class='share-block'>" +
        "<h3 ng-if='!title'>" + gettextCatalog.getString('Share this page') + '</h3>' +
        "<h4 ng-if='title'>" + gettextCatalog.getString('Share this page') + '</h4>' +
        "<span class='st_facebook_large' displayText='Facebook' st_url='{{ sharethis }}' st_title='{{title}}' st_summary='{{description}}' st_image={{image}}></span>" +
        "<span class='st_twitter_large' displayText='Tweet'  st_url='{{ sharethis }}' st_title='{{title}}' st_summary='{{description}}' st_image='{{image}}'></span>" +
        "<span class='st_googleplus_large' displayText='Google +' st_url='{{ sharethis }}' st_title='{{title}}' st_summary='{{description}}' st_image='{{image}}' ng-if='gPlus'></span>" +
        "<span class='st_email_large' displayText='Email' st_url='{{ sharethis }}' st_title='{{title}}' st_summary='{{description}}' st_image='{{image}}' ng-if='email'></span>" +
        '</div>',
    link: function (scope) {
      window.switchTo5x = true;
      if (window.stButtons) {
        init();
        return true;
      }

      var e = document.createElement('script');
      e.type = 'text/javascript';
      e.async = true;
      e.onload = function () {
        try {
          window.stLight.options({
            publisher: 'f97c142b-bcaa-4204-9884-58c21874f47f',
            doNotHash: false,
            doNotCopy: true,
            hashAddressBar: false,
          });

          $timeout(init, 100);
        } catch (error) {
          console.error(error);
        }
      };
      e.src = (document.location.protocol === 'https:' ? 'https://ws' : 'http://w') + '.sharethis.com/button/buttons.js';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(e, s);

      function init() {
        scope.sharethis = scope.url && scope.url.length ? window.location.origin + scope.url : window.location.href;
        scope.title = scope.title || $rootScope.GplusTitle;
        scope.description = scope.description || $rootScope.description;
        scope.image = $rootScope.seoImg;
        scope.$watch('sharethis + title + description + seoImg + url', function () {
          $timeout(function () {
            if (window.stButtons && typeof window.stButtons.locateElements === 'function') {
              window.stButtons.locateElements();
            }
          });
        });
      }

      return true;
    },
  };
});
